import styled from "styled-components";
import {
  BASIC_BROWN,
  BASIC_GRAY,
  BASIC_GRAY_BACKGROUND,
  BASIC_ORANGE,
  BASIC_WHITE,
} from "../../../constants/colors";
import { CouponExternal } from "../../../ducks/coupon";
import { useAsset } from "../../../hooks/useAsset";
import { formatDateTime } from "../../../utils/date";
import { StyledCheckbox } from "../../atoms/Checkbox";

type Props = {
  coupon: CouponExternal;
  isUsed: boolean;
  usedAmount: number;
  onSelect: () => void;
};

export const AppCouponItem: React.FC<Props> = ({
  coupon,
  isUsed,
  usedAmount,
  onSelect,
}) => {
  const { baseDir } = useAsset();
  return (
    <CouponItemContainer $isUsed={isUsed} onClick={onSelect}>
      <CouponItemHeader>
        <CouponImage
          src={coupon.imageUrl || baseDir + "/assets/images/menu_dummy@2x.jpg"}
          width={100}
          height={100}
          alt={coupon.name}
        />

        <CouponDetail>
          <CouponExpiration $isUsed={isUsed}>
            【有効期限】{" "}
            {formatDateTime(coupon.endAvailableDate, false, "YYYY/MM/DD HH:mm")}
            <StyledCheckbox
              type="checkbox"
              checked
              readOnly
              $checkboxStyle="selection"
              style={{
                margin: "0px",
                display: isUsed ? "inline-block" : "none",
              }}
            />
          </CouponExpiration>
          <CouponName>{coupon.name}</CouponName>
        </CouponDetail>
      </CouponItemHeader>

      {isUsed ? (
        <CouponUsedText>
          {usedAmount > 0 ? (
            <CouponUsedAmount>{usedAmount}枚</CouponUsedAmount>
          ) : null}
          適用済み
        </CouponUsedText>
      ) : (
        <CouponSelectionText>このクーポンを使う</CouponSelectionText>
      )}
    </CouponItemContainer>
  );
};

const CouponItemContainer = styled.div<{ $isUsed?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
  background-color: ${BASIC_WHITE};
  border: 2px solid ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_GRAY)};
  width: 90%;
  max-width: 600px;
  cursor: pointer;
`;

const CouponItemHeader = styled.div`
  display: flex;
  width: 100%;
`;

const CouponImage = styled.img`
  flex: 1;
  object-fit: cover;
`;

const CouponDetail = styled.div`
  flex: 2;
`;

const CouponExpiration = styled.div<{ $isUsed?: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
  background-color: ${BASIC_GRAY_BACKGROUND};
  color: ${BASIC_GRAY};
  padding-bottom: ${({ $isUsed }) => ($isUsed ? "0" : "6px")};
`;

const CouponName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${BASIC_ORANGE};
  padding: 5px;
`;

const CouponSelectionText = styled.div`
  font-size: 12px;
  background-color: ${BASIC_BROWN};
  color: ${BASIC_WHITE};
  text-align: center;
  width: 100%;
  padding: 2px 0;
  box-sizing: border-box;
`;

const CouponUsedText = styled.div`
  font-size: 10px;
  background-color: ${BASIC_ORANGE};
  color: ${BASIC_WHITE};
  text-align: right;
  width: 100%;
  padding: 2px 0;
  box-sizing: border-box;
`;

const CouponUsedAmount = styled.span`
  font-size: 12px;
  margin-right: 5px;
`;
